module.exports = __webpack_public_path__ + "img/tool_icon.1d3d40a6.svg";